export const PERIODS_CHANGE_RP_STATUS_BEGIN = 'PERIODS_CHANGE_RP_STATUS_BEGIN';
export const PERIODS_CHANGE_RP_STATUS_SUCCESS = 'PERIODS_CHANGE_RP_STATUS_SUCCESS';
export const PERIODS_CHANGE_RP_STATUS_FAILURE = 'PERIODS_CHANGE_RP_STATUS_FAILURE';
export const PERIODS_CHANGE_RP_STATUS_DISMISS_ERROR = 'PERIODS_CHANGE_RP_STATUS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/periods/redux/constants.js